import { render, staticRenderFns } from "./SamFormGroup.vue?vue&type=template&id=4c539c3a&scoped=true&"
import script from "./SamFormGroup.vue?vue&type=script&lang=js&"
export * from "./SamFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./SamFormGroup.vue?vue&type=style&index=0&id=4c539c3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c539c3a",
  null
  
)

export default component.exports